import { Component } from '@angular/core';

@Component({
  selector: 'app-attendance-report',
  standalone: true,
  imports: [],
  templateUrl: './attendance-report.component.html',
  styleUrl: './attendance-report.component.css'
})
export class AttendanceReportComponent {

}
